/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AppRouteImport } from './routes/app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SupportRouteImport } from './routes/support'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAcquisitionRouteImport } from './routes/admin/acquisition'
import { Route as AdminActivityRouteImport } from './routes/admin/activity'
import { Route as AdminAdminUsersRouteImport } from './routes/admin/admin-users'
import { Route as AdminAnalyticsRouteImport } from './routes/admin/analytics'
import { Route as AdminAppVersionRouteImport } from './routes/admin/app-version'
import { Route as AdminAppVersionsRouteImport } from './routes/admin/app-versions'
import { Route as AdminCohortsRouteImport } from './routes/admin/cohorts'
import { Route as AdminCrosswordsRouteImport } from './routes/admin/crosswords'
import { Route as AdminDeviceInfoRouteImport } from './routes/admin/device-info'
import { Route as AdminDevicesRouteImport } from './routes/admin/devices'
import { Route as AdminDictionaryRouteImport } from './routes/admin/dictionary'
import { Route as AdminDonationsRouteImport } from './routes/admin/donations'
import { Route as AdminEngagementRouteImport } from './routes/admin/engagement'
import { Route as AdminFeatureFlagsRouteImport } from './routes/admin/feature-flags'
import { Route as AdminFeaturedResourcesRouteImport } from './routes/admin/featured-resources'
import { Route as AdminFeedbackRouteImport } from './routes/admin/feedback'
import { Route as AdminFlashcardSetsRouteImport } from './routes/admin/flashcard-sets'
import { Route as AdminGamesRouteImport } from './routes/admin/games'
import { Route as AdminHeroCardsRouteImport } from './routes/admin/hero-cards'
import { Route as AdminLearningRouteImport } from './routes/admin/learning'
import { Route as AdminMetricsRouteImport } from './routes/admin/metrics'
import { Route as AdminPushRouteImport } from './routes/admin/push'
import { Route as AdminSentencePuzzlesRouteImport } from './routes/admin/sentence-puzzles'
import { Route as AdminStickerPacksRouteImport } from './routes/admin/sticker-packs'
import { Route as AdminStorybooksRouteImport } from './routes/admin/storybooks'
import { Route as AdminStreaksRouteImport } from './routes/admin/streaks'
import { Route as AdminSupportRouteImport } from './routes/admin/support'
import { Route as AdminTermSheetsRouteImport } from './routes/admin/term-sheets'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminVillageRouteImport } from './routes/admin/village'
import { Route as AdminVillageMapsRouteImport } from './routes/admin/village-maps'
import { Route as AdminWebRouteImport } from './routes/admin/web'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppAlphabetRouteImport } from './routes/app/alphabet'
import { Route as AppResourcesRouteImport } from './routes/app/resources'
import { Route as AppSearchRouteImport } from './routes/app/search'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppSubscribeRouteImport } from './routes/app/subscribe'
import { Route as AppSupportRouteImport } from './routes/app/support'
import { Route as AuthSignInRouteImport } from './routes/auth/sign-in'
import { Route as AuthSignUpRouteImport } from './routes/auth/sign-up'
import { Route as AdminAnalyticsPulseRouteImport } from './routes/admin/analytics.pulse'
import { Route as AdminAnalyticsSessionsRouteImport } from './routes/admin/analytics.sessions'
import { Route as AdminAnalyticsTimelineRouteImport } from './routes/admin/analytics.timeline'
import { Route as AdminCrosswordsIdRouteImport } from './routes/admin/crosswords.$id'
import { Route as AdminDevicesInstallationIdRouteImport } from './routes/admin/devices.$installationId'
import { Route as AdminDictionaryIndexRouteImport } from './routes/admin/dictionary.index'
import { Route as AdminDictionaryListRouteImport } from './routes/admin/dictionary.list'
import { Route as AdminFeedbackIdRouteImport } from './routes/admin/feedback.$id'
import { Route as AdminFlashcardSetsIdRouteImport } from './routes/admin/flashcard-sets.$id'
import { Route as AdminGamesSlugRouteImport } from './routes/admin/games.$slug'
import { Route as AdminSentencePuzzlesIdRouteImport } from './routes/admin/sentence-puzzles.$id'
import { Route as AdminStickerPacksIdRouteImport } from './routes/admin/sticker-packs.$id'
import { Route as AdminStorybooksIdRouteImport } from './routes/admin/storybooks.$id'
import { Route as AdminSupportIdRouteImport } from './routes/admin/support.$id'
import { Route as AdminTermSheetsIdRouteImport } from './routes/admin/term-sheets.$id'
import { Route as AdminTermSheetsPracticeRouteImport } from './routes/admin/term-sheets.practice'
import { Route as AdminUsersUserIdRouteImport } from './routes/admin/users.$userId'
import { Route as AdminVillageMapsIdRouteImport } from './routes/admin/village-maps.$id'
import { Route as AppCrosswordsIndexRouteImport } from './routes/app/crosswords/index'
import { Route as AppCrosswordsDateRouteImport } from './routes/app/crosswords/$date'
import { Route as AppCrosswordsLeaderboardRouteImport } from './routes/app/crosswords/leaderboard'
import { Route as AppDiagramsSlugRouteImport } from './routes/app/diagrams/$slug'
import { Route as AppFlashcardsSlugRouteImport } from './routes/app/flashcards/$slug'
import { Route as AppGamesIndexRouteImport } from './routes/app/games/index'
import { Route as AppGamesSlugRouteImport } from './routes/app/games/$slug'
import { Route as AppSheetsSlugRouteImport } from './routes/app/sheets/$slug'
import { Route as AppSongsSlugRouteImport } from './routes/app/songs/$slug'
import { Route as AppStickersIndexRouteImport } from './routes/app/stickers/index'
import { Route as AppStorybooksSlugRouteImport } from './routes/app/storybooks/$slug'
import { Route as AuthSignInIndexRouteImport } from './routes/auth/sign-in.index'
import { Route as AuthSignInSplatRouteImport } from './routes/auth/sign-in.$'
import { Route as AuthSignUpIndexRouteImport } from './routes/auth/sign-up.index'
import { Route as AuthSignUpSplatRouteImport } from './routes/auth/sign-up.$'
import { Route as AdminDictionaryEntryIdRouteImport } from './routes/admin/dictionary.entry.$id'
import { Route as AppGamesSlugLeaderboardRouteImport } from './routes/app/games/$slug/leaderboard'
import { Route as AppStickersScenesSceneIdRouteImport } from './routes/app/stickers/scenes/$sceneId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAcquisitionRoute = AdminAcquisitionRouteImport.update({
  id: '/acquisition',
  path: '/acquisition',
  getParentRoute: () => AdminRoute,
} as any)
const AdminActivityRoute = AdminActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAdminUsersRoute = AdminAdminUsersRouteImport.update({
  id: '/admin-users',
  path: '/admin-users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAppVersionRoute = AdminAppVersionRouteImport.update({
  id: '/app-version',
  path: '/app-version',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAppVersionsRoute = AdminAppVersionsRouteImport.update({
  id: '/app-versions',
  path: '/app-versions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCohortsRoute = AdminCohortsRouteImport.update({
  id: '/cohorts',
  path: '/cohorts',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCrosswordsRoute = AdminCrosswordsRouteImport.update({
  id: '/crosswords',
  path: '/crosswords',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDeviceInfoRoute = AdminDeviceInfoRouteImport.update({
  id: '/device-info',
  path: '/device-info',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDevicesRoute = AdminDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDictionaryRoute = AdminDictionaryRouteImport.update({
  id: '/dictionary',
  path: '/dictionary',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDonationsRoute = AdminDonationsRouteImport.update({
  id: '/donations',
  path: '/donations',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEngagementRoute = AdminEngagementRouteImport.update({
  id: '/engagement',
  path: '/engagement',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeatureFlagsRoute = AdminFeatureFlagsRouteImport.update({
  id: '/feature-flags',
  path: '/feature-flags',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeaturedResourcesRoute = AdminFeaturedResourcesRouteImport.update({
  id: '/featured-resources',
  path: '/featured-resources',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeedbackRoute = AdminFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFlashcardSetsRoute = AdminFlashcardSetsRouteImport.update({
  id: '/flashcard-sets',
  path: '/flashcard-sets',
  getParentRoute: () => AdminRoute,
} as any)
const AdminGamesRoute = AdminGamesRouteImport.update({
  id: '/games',
  path: '/games',
  getParentRoute: () => AdminRoute,
} as any)
const AdminHeroCardsRoute = AdminHeroCardsRouteImport.update({
  id: '/hero-cards',
  path: '/hero-cards',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLearningRoute = AdminLearningRouteImport.update({
  id: '/learning',
  path: '/learning',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMetricsRoute = AdminMetricsRouteImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPushRoute = AdminPushRouteImport.update({
  id: '/push',
  path: '/push',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSentencePuzzlesRoute = AdminSentencePuzzlesRouteImport.update({
  id: '/sentence-puzzles',
  path: '/sentence-puzzles',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStickerPacksRoute = AdminStickerPacksRouteImport.update({
  id: '/sticker-packs',
  path: '/sticker-packs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStorybooksRoute = AdminStorybooksRouteImport.update({
  id: '/storybooks',
  path: '/storybooks',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStreaksRoute = AdminStreaksRouteImport.update({
  id: '/streaks',
  path: '/streaks',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSupportRoute = AdminSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTermSheetsRoute = AdminTermSheetsRouteImport.update({
  id: '/term-sheets',
  path: '/term-sheets',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminVillageRoute = AdminVillageRouteImport.update({
  id: '/village',
  path: '/village',
  getParentRoute: () => AdminRoute,
} as any)
const AdminVillageMapsRoute = AdminVillageMapsRouteImport.update({
  id: '/village-maps',
  path: '/village-maps',
  getParentRoute: () => AdminRoute,
} as any)
const AdminWebRoute = AdminWebRouteImport.update({
  id: '/web',
  path: '/web',
  getParentRoute: () => AdminRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAlphabetRoute = AppAlphabetRouteImport.update({
  id: '/alphabet',
  path: '/alphabet',
  getParentRoute: () => AppRoute,
} as any)
const AppResourcesRoute = AppResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => AppRoute,
} as any)
const AppSearchRoute = AppSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSubscribeRoute = AppSubscribeRouteImport.update({
  id: '/subscribe',
  path: '/subscribe',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportRoute = AppSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AppRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/auth/sign-in',
  path: '/auth/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/auth/sign-up',
  path: '/auth/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAnalyticsPulseRoute = AdminAnalyticsPulseRouteImport.update({
  id: '/pulse',
  path: '/pulse',
  getParentRoute: () => AdminAnalyticsRoute,
} as any)
const AdminAnalyticsSessionsRoute = AdminAnalyticsSessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => AdminAnalyticsRoute,
} as any)
const AdminAnalyticsTimelineRoute = AdminAnalyticsTimelineRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => AdminAnalyticsRoute,
} as any)
const AdminCrosswordsIdRoute = AdminCrosswordsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminCrosswordsRoute,
} as any)
const AdminDevicesInstallationIdRoute =
  AdminDevicesInstallationIdRouteImport.update({
    id: '/$installationId',
    path: '/$installationId',
    getParentRoute: () => AdminDevicesRoute,
  } as any)
const AdminDictionaryIndexRoute = AdminDictionaryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminDictionaryRoute,
} as any)
const AdminDictionaryListRoute = AdminDictionaryListRouteImport.update({
  id: '/list',
  path: '/list',
  getParentRoute: () => AdminDictionaryRoute,
} as any)
const AdminFeedbackIdRoute = AdminFeedbackIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminFeedbackRoute,
} as any)
const AdminFlashcardSetsIdRoute = AdminFlashcardSetsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminFlashcardSetsRoute,
} as any)
const AdminGamesSlugRoute = AdminGamesSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => AdminGamesRoute,
} as any)
const AdminSentencePuzzlesIdRoute = AdminSentencePuzzlesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminSentencePuzzlesRoute,
} as any)
const AdminStickerPacksIdRoute = AdminStickerPacksIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminStickerPacksRoute,
} as any)
const AdminStorybooksIdRoute = AdminStorybooksIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminStorybooksRoute,
} as any)
const AdminSupportIdRoute = AdminSupportIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminSupportRoute,
} as any)
const AdminTermSheetsIdRoute = AdminTermSheetsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminTermSheetsRoute,
} as any)
const AdminTermSheetsPracticeRoute = AdminTermSheetsPracticeRouteImport.update({
  id: '/practice',
  path: '/practice',
  getParentRoute: () => AdminTermSheetsRoute,
} as any)
const AdminUsersUserIdRoute = AdminUsersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AdminUsersRoute,
} as any)
const AdminVillageMapsIdRoute = AdminVillageMapsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminVillageMapsRoute,
} as any)
const AppCrosswordsIndexRoute = AppCrosswordsIndexRouteImport.update({
  id: '/crosswords/',
  path: '/crosswords/',
  getParentRoute: () => AppRoute,
} as any)
const AppCrosswordsDateRoute = AppCrosswordsDateRouteImport.update({
  id: '/crosswords/$date',
  path: '/crosswords/$date',
  getParentRoute: () => AppRoute,
} as any)
const AppCrosswordsLeaderboardRoute =
  AppCrosswordsLeaderboardRouteImport.update({
    id: '/crosswords/leaderboard',
    path: '/crosswords/leaderboard',
    getParentRoute: () => AppRoute,
  } as any)
const AppDiagramsSlugRoute = AppDiagramsSlugRouteImport.update({
  id: '/diagrams/$slug',
  path: '/diagrams/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppFlashcardsSlugRoute = AppFlashcardsSlugRouteImport.update({
  id: '/flashcards/$slug',
  path: '/flashcards/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppGamesIndexRoute = AppGamesIndexRouteImport.update({
  id: '/games/',
  path: '/games/',
  getParentRoute: () => AppRoute,
} as any)
const AppGamesSlugRoute = AppGamesSlugRouteImport.update({
  id: '/games/$slug',
  path: '/games/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppSheetsSlugRoute = AppSheetsSlugRouteImport.update({
  id: '/sheets/$slug',
  path: '/sheets/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppSongsSlugRoute = AppSongsSlugRouteImport.update({
  id: '/songs/$slug',
  path: '/songs/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppStickersIndexRoute = AppStickersIndexRouteImport.update({
  id: '/stickers/',
  path: '/stickers/',
  getParentRoute: () => AppRoute,
} as any)
const AppStorybooksSlugRoute = AppStorybooksSlugRouteImport.update({
  id: '/storybooks/$slug',
  path: '/storybooks/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AuthSignInIndexRoute = AuthSignInIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSignInRoute,
} as any)
const AuthSignInSplatRoute = AuthSignInSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthSignInRoute,
} as any)
const AuthSignUpIndexRoute = AuthSignUpIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSignUpRoute,
} as any)
const AuthSignUpSplatRoute = AuthSignUpSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthSignUpRoute,
} as any)
const AdminDictionaryEntryIdRoute = AdminDictionaryEntryIdRouteImport.update({
  id: '/entry/$id',
  path: '/entry/$id',
  getParentRoute: () => AdminDictionaryRoute,
} as any)
const AppGamesSlugLeaderboardRoute = AppGamesSlugLeaderboardRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => AppGamesSlugRoute,
} as any)
const AppStickersScenesSceneIdRoute =
  AppStickersScenesSceneIdRouteImport.update({
    id: '/stickers/scenes/$sceneId',
    path: '/stickers/scenes/$sceneId',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/admin/acquisition': typeof AdminAcquisitionRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/admin-users': typeof AdminAdminUsersRoute
  '/admin/analytics': typeof AdminAnalyticsRouteWithChildren
  '/admin/app-version': typeof AdminAppVersionRoute
  '/admin/app-versions': typeof AdminAppVersionsRoute
  '/admin/cohorts': typeof AdminCohortsRoute
  '/admin/crosswords': typeof AdminCrosswordsRouteWithChildren
  '/admin/device-info': typeof AdminDeviceInfoRoute
  '/admin/devices': typeof AdminDevicesRouteWithChildren
  '/admin/dictionary': typeof AdminDictionaryRouteWithChildren
  '/admin/donations': typeof AdminDonationsRoute
  '/admin/engagement': typeof AdminEngagementRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/featured-resources': typeof AdminFeaturedResourcesRoute
  '/admin/feedback': typeof AdminFeedbackRouteWithChildren
  '/admin/flashcard-sets': typeof AdminFlashcardSetsRouteWithChildren
  '/admin/games': typeof AdminGamesRouteWithChildren
  '/admin/hero-cards': typeof AdminHeroCardsRoute
  '/admin/learning': typeof AdminLearningRoute
  '/admin/metrics': typeof AdminMetricsRoute
  '/admin/push': typeof AdminPushRoute
  '/admin/sentence-puzzles': typeof AdminSentencePuzzlesRouteWithChildren
  '/admin/sticker-packs': typeof AdminStickerPacksRouteWithChildren
  '/admin/storybooks': typeof AdminStorybooksRouteWithChildren
  '/admin/streaks': typeof AdminStreaksRoute
  '/admin/support': typeof AdminSupportRouteWithChildren
  '/admin/term-sheets': typeof AdminTermSheetsRouteWithChildren
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/admin/village': typeof AdminVillageRoute
  '/admin/village-maps': typeof AdminVillageMapsRouteWithChildren
  '/admin/web': typeof AdminWebRoute
  '/app/alphabet': typeof AppAlphabetRoute
  '/app/resources': typeof AppResourcesRoute
  '/app/search': typeof AppSearchRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/subscribe': typeof AppSubscribeRoute
  '/app/support': typeof AppSupportRoute
  '/auth/sign-in': typeof AuthSignInRouteWithChildren
  '/auth/sign-up': typeof AuthSignUpRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/admin/analytics/pulse': typeof AdminAnalyticsPulseRoute
  '/admin/analytics/sessions': typeof AdminAnalyticsSessionsRoute
  '/admin/analytics/timeline': typeof AdminAnalyticsTimelineRoute
  '/admin/crosswords/$id': typeof AdminCrosswordsIdRoute
  '/admin/devices/$installationId': typeof AdminDevicesInstallationIdRoute
  '/admin/dictionary/list': typeof AdminDictionaryListRoute
  '/admin/feedback/$id': typeof AdminFeedbackIdRoute
  '/admin/flashcard-sets/$id': typeof AdminFlashcardSetsIdRoute
  '/admin/games/$slug': typeof AdminGamesSlugRoute
  '/admin/sentence-puzzles/$id': typeof AdminSentencePuzzlesIdRoute
  '/admin/sticker-packs/$id': typeof AdminStickerPacksIdRoute
  '/admin/storybooks/$id': typeof AdminStorybooksIdRoute
  '/admin/support/$id': typeof AdminSupportIdRoute
  '/admin/term-sheets/$id': typeof AdminTermSheetsIdRoute
  '/admin/term-sheets/practice': typeof AdminTermSheetsPracticeRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/admin/village-maps/$id': typeof AdminVillageMapsIdRoute
  '/app/crosswords/$date': typeof AppCrosswordsDateRoute
  '/app/crosswords/leaderboard': typeof AppCrosswordsLeaderboardRoute
  '/app/diagrams/$slug': typeof AppDiagramsSlugRoute
  '/app/flashcards/$slug': typeof AppFlashcardsSlugRoute
  '/app/games/$slug': typeof AppGamesSlugRouteWithChildren
  '/app/sheets/$slug': typeof AppSheetsSlugRoute
  '/app/songs/$slug': typeof AppSongsSlugRoute
  '/app/storybooks/$slug': typeof AppStorybooksSlugRoute
  '/auth/sign-in/$': typeof AuthSignInSplatRoute
  '/auth/sign-up/$': typeof AuthSignUpSplatRoute
  '/admin/dictionary/': typeof AdminDictionaryIndexRoute
  '/app/crosswords/': typeof AppCrosswordsIndexRoute
  '/app/games/': typeof AppGamesIndexRoute
  '/app/stickers/': typeof AppStickersIndexRoute
  '/auth/sign-in/': typeof AuthSignInIndexRoute
  '/auth/sign-up/': typeof AuthSignUpIndexRoute
  '/admin/dictionary/entry/$id': typeof AdminDictionaryEntryIdRoute
  '/app/games/$slug/leaderboard': typeof AppGamesSlugLeaderboardRoute
  '/app/stickers/scenes/$sceneId': typeof AppStickersScenesSceneIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/admin/acquisition': typeof AdminAcquisitionRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/admin-users': typeof AdminAdminUsersRoute
  '/admin/analytics': typeof AdminAnalyticsRouteWithChildren
  '/admin/app-version': typeof AdminAppVersionRoute
  '/admin/app-versions': typeof AdminAppVersionsRoute
  '/admin/cohorts': typeof AdminCohortsRoute
  '/admin/crosswords': typeof AdminCrosswordsRouteWithChildren
  '/admin/device-info': typeof AdminDeviceInfoRoute
  '/admin/devices': typeof AdminDevicesRouteWithChildren
  '/admin/donations': typeof AdminDonationsRoute
  '/admin/engagement': typeof AdminEngagementRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/featured-resources': typeof AdminFeaturedResourcesRoute
  '/admin/feedback': typeof AdminFeedbackRouteWithChildren
  '/admin/flashcard-sets': typeof AdminFlashcardSetsRouteWithChildren
  '/admin/games': typeof AdminGamesRouteWithChildren
  '/admin/hero-cards': typeof AdminHeroCardsRoute
  '/admin/learning': typeof AdminLearningRoute
  '/admin/metrics': typeof AdminMetricsRoute
  '/admin/push': typeof AdminPushRoute
  '/admin/sentence-puzzles': typeof AdminSentencePuzzlesRouteWithChildren
  '/admin/sticker-packs': typeof AdminStickerPacksRouteWithChildren
  '/admin/storybooks': typeof AdminStorybooksRouteWithChildren
  '/admin/streaks': typeof AdminStreaksRoute
  '/admin/support': typeof AdminSupportRouteWithChildren
  '/admin/term-sheets': typeof AdminTermSheetsRouteWithChildren
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/admin/village': typeof AdminVillageRoute
  '/admin/village-maps': typeof AdminVillageMapsRouteWithChildren
  '/admin/web': typeof AdminWebRoute
  '/app/alphabet': typeof AppAlphabetRoute
  '/app/resources': typeof AppResourcesRoute
  '/app/search': typeof AppSearchRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/subscribe': typeof AppSubscribeRoute
  '/app/support': typeof AppSupportRoute
  '/admin': typeof AdminIndexRoute
  '/app': typeof AppIndexRoute
  '/admin/analytics/pulse': typeof AdminAnalyticsPulseRoute
  '/admin/analytics/sessions': typeof AdminAnalyticsSessionsRoute
  '/admin/analytics/timeline': typeof AdminAnalyticsTimelineRoute
  '/admin/crosswords/$id': typeof AdminCrosswordsIdRoute
  '/admin/devices/$installationId': typeof AdminDevicesInstallationIdRoute
  '/admin/dictionary/list': typeof AdminDictionaryListRoute
  '/admin/feedback/$id': typeof AdminFeedbackIdRoute
  '/admin/flashcard-sets/$id': typeof AdminFlashcardSetsIdRoute
  '/admin/games/$slug': typeof AdminGamesSlugRoute
  '/admin/sentence-puzzles/$id': typeof AdminSentencePuzzlesIdRoute
  '/admin/sticker-packs/$id': typeof AdminStickerPacksIdRoute
  '/admin/storybooks/$id': typeof AdminStorybooksIdRoute
  '/admin/support/$id': typeof AdminSupportIdRoute
  '/admin/term-sheets/$id': typeof AdminTermSheetsIdRoute
  '/admin/term-sheets/practice': typeof AdminTermSheetsPracticeRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/admin/village-maps/$id': typeof AdminVillageMapsIdRoute
  '/app/crosswords/$date': typeof AppCrosswordsDateRoute
  '/app/crosswords/leaderboard': typeof AppCrosswordsLeaderboardRoute
  '/app/diagrams/$slug': typeof AppDiagramsSlugRoute
  '/app/flashcards/$slug': typeof AppFlashcardsSlugRoute
  '/app/games/$slug': typeof AppGamesSlugRouteWithChildren
  '/app/sheets/$slug': typeof AppSheetsSlugRoute
  '/app/songs/$slug': typeof AppSongsSlugRoute
  '/app/storybooks/$slug': typeof AppStorybooksSlugRoute
  '/auth/sign-in/$': typeof AuthSignInSplatRoute
  '/auth/sign-up/$': typeof AuthSignUpSplatRoute
  '/admin/dictionary': typeof AdminDictionaryIndexRoute
  '/app/crosswords': typeof AppCrosswordsIndexRoute
  '/app/games': typeof AppGamesIndexRoute
  '/app/stickers': typeof AppStickersIndexRoute
  '/auth/sign-in': typeof AuthSignInIndexRoute
  '/auth/sign-up': typeof AuthSignUpIndexRoute
  '/admin/dictionary/entry/$id': typeof AdminDictionaryEntryIdRoute
  '/app/games/$slug/leaderboard': typeof AppGamesSlugLeaderboardRoute
  '/app/stickers/scenes/$sceneId': typeof AppStickersScenesSceneIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/admin/acquisition': typeof AdminAcquisitionRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/admin-users': typeof AdminAdminUsersRoute
  '/admin/analytics': typeof AdminAnalyticsRouteWithChildren
  '/admin/app-version': typeof AdminAppVersionRoute
  '/admin/app-versions': typeof AdminAppVersionsRoute
  '/admin/cohorts': typeof AdminCohortsRoute
  '/admin/crosswords': typeof AdminCrosswordsRouteWithChildren
  '/admin/device-info': typeof AdminDeviceInfoRoute
  '/admin/devices': typeof AdminDevicesRouteWithChildren
  '/admin/dictionary': typeof AdminDictionaryRouteWithChildren
  '/admin/donations': typeof AdminDonationsRoute
  '/admin/engagement': typeof AdminEngagementRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/featured-resources': typeof AdminFeaturedResourcesRoute
  '/admin/feedback': typeof AdminFeedbackRouteWithChildren
  '/admin/flashcard-sets': typeof AdminFlashcardSetsRouteWithChildren
  '/admin/games': typeof AdminGamesRouteWithChildren
  '/admin/hero-cards': typeof AdminHeroCardsRoute
  '/admin/learning': typeof AdminLearningRoute
  '/admin/metrics': typeof AdminMetricsRoute
  '/admin/push': typeof AdminPushRoute
  '/admin/sentence-puzzles': typeof AdminSentencePuzzlesRouteWithChildren
  '/admin/sticker-packs': typeof AdminStickerPacksRouteWithChildren
  '/admin/storybooks': typeof AdminStorybooksRouteWithChildren
  '/admin/streaks': typeof AdminStreaksRoute
  '/admin/support': typeof AdminSupportRouteWithChildren
  '/admin/term-sheets': typeof AdminTermSheetsRouteWithChildren
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/admin/village': typeof AdminVillageRoute
  '/admin/village-maps': typeof AdminVillageMapsRouteWithChildren
  '/admin/web': typeof AdminWebRoute
  '/app/alphabet': typeof AppAlphabetRoute
  '/app/resources': typeof AppResourcesRoute
  '/app/search': typeof AppSearchRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/subscribe': typeof AppSubscribeRoute
  '/app/support': typeof AppSupportRoute
  '/auth/sign-in': typeof AuthSignInRouteWithChildren
  '/auth/sign-up': typeof AuthSignUpRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/admin/analytics/pulse': typeof AdminAnalyticsPulseRoute
  '/admin/analytics/sessions': typeof AdminAnalyticsSessionsRoute
  '/admin/analytics/timeline': typeof AdminAnalyticsTimelineRoute
  '/admin/crosswords/$id': typeof AdminCrosswordsIdRoute
  '/admin/devices/$installationId': typeof AdminDevicesInstallationIdRoute
  '/admin/dictionary/list': typeof AdminDictionaryListRoute
  '/admin/feedback/$id': typeof AdminFeedbackIdRoute
  '/admin/flashcard-sets/$id': typeof AdminFlashcardSetsIdRoute
  '/admin/games/$slug': typeof AdminGamesSlugRoute
  '/admin/sentence-puzzles/$id': typeof AdminSentencePuzzlesIdRoute
  '/admin/sticker-packs/$id': typeof AdminStickerPacksIdRoute
  '/admin/storybooks/$id': typeof AdminStorybooksIdRoute
  '/admin/support/$id': typeof AdminSupportIdRoute
  '/admin/term-sheets/$id': typeof AdminTermSheetsIdRoute
  '/admin/term-sheets/practice': typeof AdminTermSheetsPracticeRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/admin/village-maps/$id': typeof AdminVillageMapsIdRoute
  '/app/crosswords/$date': typeof AppCrosswordsDateRoute
  '/app/crosswords/leaderboard': typeof AppCrosswordsLeaderboardRoute
  '/app/diagrams/$slug': typeof AppDiagramsSlugRoute
  '/app/flashcards/$slug': typeof AppFlashcardsSlugRoute
  '/app/games/$slug': typeof AppGamesSlugRouteWithChildren
  '/app/sheets/$slug': typeof AppSheetsSlugRoute
  '/app/songs/$slug': typeof AppSongsSlugRoute
  '/app/storybooks/$slug': typeof AppStorybooksSlugRoute
  '/auth/sign-in/$': typeof AuthSignInSplatRoute
  '/auth/sign-up/$': typeof AuthSignUpSplatRoute
  '/admin/dictionary/': typeof AdminDictionaryIndexRoute
  '/app/crosswords/': typeof AppCrosswordsIndexRoute
  '/app/games/': typeof AppGamesIndexRoute
  '/app/stickers/': typeof AppStickersIndexRoute
  '/auth/sign-in/': typeof AuthSignInIndexRoute
  '/auth/sign-up/': typeof AuthSignUpIndexRoute
  '/admin/dictionary/entry/$id': typeof AdminDictionaryEntryIdRoute
  '/app/games/$slug/leaderboard': typeof AppGamesSlugLeaderboardRoute
  '/app/stickers/scenes/$sceneId': typeof AppStickersScenesSceneIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/app'
    | '/login'
    | '/pricing'
    | '/privacy'
    | '/support'
    | '/terms'
    | '/admin/acquisition'
    | '/admin/activity'
    | '/admin/admin-users'
    | '/admin/analytics'
    | '/admin/app-version'
    | '/admin/app-versions'
    | '/admin/cohorts'
    | '/admin/crosswords'
    | '/admin/device-info'
    | '/admin/devices'
    | '/admin/dictionary'
    | '/admin/donations'
    | '/admin/engagement'
    | '/admin/feature-flags'
    | '/admin/featured-resources'
    | '/admin/feedback'
    | '/admin/flashcard-sets'
    | '/admin/games'
    | '/admin/hero-cards'
    | '/admin/learning'
    | '/admin/metrics'
    | '/admin/push'
    | '/admin/sentence-puzzles'
    | '/admin/sticker-packs'
    | '/admin/storybooks'
    | '/admin/streaks'
    | '/admin/support'
    | '/admin/term-sheets'
    | '/admin/users'
    | '/admin/village'
    | '/admin/village-maps'
    | '/admin/web'
    | '/app/alphabet'
    | '/app/resources'
    | '/app/search'
    | '/app/settings'
    | '/app/subscribe'
    | '/app/support'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/admin/'
    | '/app/'
    | '/admin/analytics/pulse'
    | '/admin/analytics/sessions'
    | '/admin/analytics/timeline'
    | '/admin/crosswords/$id'
    | '/admin/devices/$installationId'
    | '/admin/dictionary/list'
    | '/admin/feedback/$id'
    | '/admin/flashcard-sets/$id'
    | '/admin/games/$slug'
    | '/admin/sentence-puzzles/$id'
    | '/admin/sticker-packs/$id'
    | '/admin/storybooks/$id'
    | '/admin/support/$id'
    | '/admin/term-sheets/$id'
    | '/admin/term-sheets/practice'
    | '/admin/users/$userId'
    | '/admin/village-maps/$id'
    | '/app/crosswords/$date'
    | '/app/crosswords/leaderboard'
    | '/app/diagrams/$slug'
    | '/app/flashcards/$slug'
    | '/app/games/$slug'
    | '/app/sheets/$slug'
    | '/app/songs/$slug'
    | '/app/storybooks/$slug'
    | '/auth/sign-in/$'
    | '/auth/sign-up/$'
    | '/admin/dictionary/'
    | '/app/crosswords/'
    | '/app/games/'
    | '/app/stickers/'
    | '/auth/sign-in/'
    | '/auth/sign-up/'
    | '/admin/dictionary/entry/$id'
    | '/app/games/$slug/leaderboard'
    | '/app/stickers/scenes/$sceneId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/pricing'
    | '/privacy'
    | '/support'
    | '/terms'
    | '/admin/acquisition'
    | '/admin/activity'
    | '/admin/admin-users'
    | '/admin/analytics'
    | '/admin/app-version'
    | '/admin/app-versions'
    | '/admin/cohorts'
    | '/admin/crosswords'
    | '/admin/device-info'
    | '/admin/devices'
    | '/admin/donations'
    | '/admin/engagement'
    | '/admin/feature-flags'
    | '/admin/featured-resources'
    | '/admin/feedback'
    | '/admin/flashcard-sets'
    | '/admin/games'
    | '/admin/hero-cards'
    | '/admin/learning'
    | '/admin/metrics'
    | '/admin/push'
    | '/admin/sentence-puzzles'
    | '/admin/sticker-packs'
    | '/admin/storybooks'
    | '/admin/streaks'
    | '/admin/support'
    | '/admin/term-sheets'
    | '/admin/users'
    | '/admin/village'
    | '/admin/village-maps'
    | '/admin/web'
    | '/app/alphabet'
    | '/app/resources'
    | '/app/search'
    | '/app/settings'
    | '/app/subscribe'
    | '/app/support'
    | '/admin'
    | '/app'
    | '/admin/analytics/pulse'
    | '/admin/analytics/sessions'
    | '/admin/analytics/timeline'
    | '/admin/crosswords/$id'
    | '/admin/devices/$installationId'
    | '/admin/dictionary/list'
    | '/admin/feedback/$id'
    | '/admin/flashcard-sets/$id'
    | '/admin/games/$slug'
    | '/admin/sentence-puzzles/$id'
    | '/admin/sticker-packs/$id'
    | '/admin/storybooks/$id'
    | '/admin/support/$id'
    | '/admin/term-sheets/$id'
    | '/admin/term-sheets/practice'
    | '/admin/users/$userId'
    | '/admin/village-maps/$id'
    | '/app/crosswords/$date'
    | '/app/crosswords/leaderboard'
    | '/app/diagrams/$slug'
    | '/app/flashcards/$slug'
    | '/app/games/$slug'
    | '/app/sheets/$slug'
    | '/app/songs/$slug'
    | '/app/storybooks/$slug'
    | '/auth/sign-in/$'
    | '/auth/sign-up/$'
    | '/admin/dictionary'
    | '/app/crosswords'
    | '/app/games'
    | '/app/stickers'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/admin/dictionary/entry/$id'
    | '/app/games/$slug/leaderboard'
    | '/app/stickers/scenes/$sceneId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/app'
    | '/login'
    | '/pricing'
    | '/privacy'
    | '/support'
    | '/terms'
    | '/admin/acquisition'
    | '/admin/activity'
    | '/admin/admin-users'
    | '/admin/analytics'
    | '/admin/app-version'
    | '/admin/app-versions'
    | '/admin/cohorts'
    | '/admin/crosswords'
    | '/admin/device-info'
    | '/admin/devices'
    | '/admin/dictionary'
    | '/admin/donations'
    | '/admin/engagement'
    | '/admin/feature-flags'
    | '/admin/featured-resources'
    | '/admin/feedback'
    | '/admin/flashcard-sets'
    | '/admin/games'
    | '/admin/hero-cards'
    | '/admin/learning'
    | '/admin/metrics'
    | '/admin/push'
    | '/admin/sentence-puzzles'
    | '/admin/sticker-packs'
    | '/admin/storybooks'
    | '/admin/streaks'
    | '/admin/support'
    | '/admin/term-sheets'
    | '/admin/users'
    | '/admin/village'
    | '/admin/village-maps'
    | '/admin/web'
    | '/app/alphabet'
    | '/app/resources'
    | '/app/search'
    | '/app/settings'
    | '/app/subscribe'
    | '/app/support'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/admin/'
    | '/app/'
    | '/admin/analytics/pulse'
    | '/admin/analytics/sessions'
    | '/admin/analytics/timeline'
    | '/admin/crosswords/$id'
    | '/admin/devices/$installationId'
    | '/admin/dictionary/list'
    | '/admin/feedback/$id'
    | '/admin/flashcard-sets/$id'
    | '/admin/games/$slug'
    | '/admin/sentence-puzzles/$id'
    | '/admin/sticker-packs/$id'
    | '/admin/storybooks/$id'
    | '/admin/support/$id'
    | '/admin/term-sheets/$id'
    | '/admin/term-sheets/practice'
    | '/admin/users/$userId'
    | '/admin/village-maps/$id'
    | '/app/crosswords/$date'
    | '/app/crosswords/leaderboard'
    | '/app/diagrams/$slug'
    | '/app/flashcards/$slug'
    | '/app/games/$slug'
    | '/app/sheets/$slug'
    | '/app/songs/$slug'
    | '/app/storybooks/$slug'
    | '/auth/sign-in/$'
    | '/auth/sign-up/$'
    | '/admin/dictionary/'
    | '/app/crosswords/'
    | '/app/games/'
    | '/app/stickers/'
    | '/auth/sign-in/'
    | '/auth/sign-up/'
    | '/admin/dictionary/entry/$id'
    | '/app/games/$slug/leaderboard'
    | '/app/stickers/scenes/$sceneId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  PricingRoute: typeof PricingRoute
  PrivacyRoute: typeof PrivacyRoute
  SupportRoute: typeof SupportRoute
  TermsRoute: typeof TermsRoute
  AuthSignInRoute: typeof AuthSignInRouteWithChildren
  AuthSignUpRoute: typeof AuthSignUpRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/acquisition': {
      id: '/admin/acquisition'
      path: '/acquisition'
      fullPath: '/admin/acquisition'
      preLoaderRoute: typeof AdminAcquisitionRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/activity': {
      id: '/admin/activity'
      path: '/activity'
      fullPath: '/admin/activity'
      preLoaderRoute: typeof AdminActivityRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/admin-users': {
      id: '/admin/admin-users'
      path: '/admin-users'
      fullPath: '/admin/admin-users'
      preLoaderRoute: typeof AdminAdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/app-version': {
      id: '/admin/app-version'
      path: '/app-version'
      fullPath: '/admin/app-version'
      preLoaderRoute: typeof AdminAppVersionRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/app-versions': {
      id: '/admin/app-versions'
      path: '/app-versions'
      fullPath: '/admin/app-versions'
      preLoaderRoute: typeof AdminAppVersionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/cohorts': {
      id: '/admin/cohorts'
      path: '/cohorts'
      fullPath: '/admin/cohorts'
      preLoaderRoute: typeof AdminCohortsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/crosswords': {
      id: '/admin/crosswords'
      path: '/crosswords'
      fullPath: '/admin/crosswords'
      preLoaderRoute: typeof AdminCrosswordsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/device-info': {
      id: '/admin/device-info'
      path: '/device-info'
      fullPath: '/admin/device-info'
      preLoaderRoute: typeof AdminDeviceInfoRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/devices': {
      id: '/admin/devices'
      path: '/devices'
      fullPath: '/admin/devices'
      preLoaderRoute: typeof AdminDevicesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dictionary': {
      id: '/admin/dictionary'
      path: '/dictionary'
      fullPath: '/admin/dictionary'
      preLoaderRoute: typeof AdminDictionaryRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/donations': {
      id: '/admin/donations'
      path: '/donations'
      fullPath: '/admin/donations'
      preLoaderRoute: typeof AdminDonationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/engagement': {
      id: '/admin/engagement'
      path: '/engagement'
      fullPath: '/admin/engagement'
      preLoaderRoute: typeof AdminEngagementRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/feature-flags': {
      id: '/admin/feature-flags'
      path: '/feature-flags'
      fullPath: '/admin/feature-flags'
      preLoaderRoute: typeof AdminFeatureFlagsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/featured-resources': {
      id: '/admin/featured-resources'
      path: '/featured-resources'
      fullPath: '/admin/featured-resources'
      preLoaderRoute: typeof AdminFeaturedResourcesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/feedback': {
      id: '/admin/feedback'
      path: '/feedback'
      fullPath: '/admin/feedback'
      preLoaderRoute: typeof AdminFeedbackRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/flashcard-sets': {
      id: '/admin/flashcard-sets'
      path: '/flashcard-sets'
      fullPath: '/admin/flashcard-sets'
      preLoaderRoute: typeof AdminFlashcardSetsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/games': {
      id: '/admin/games'
      path: '/games'
      fullPath: '/admin/games'
      preLoaderRoute: typeof AdminGamesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/hero-cards': {
      id: '/admin/hero-cards'
      path: '/hero-cards'
      fullPath: '/admin/hero-cards'
      preLoaderRoute: typeof AdminHeroCardsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/learning': {
      id: '/admin/learning'
      path: '/learning'
      fullPath: '/admin/learning'
      preLoaderRoute: typeof AdminLearningRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/metrics': {
      id: '/admin/metrics'
      path: '/metrics'
      fullPath: '/admin/metrics'
      preLoaderRoute: typeof AdminMetricsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/push': {
      id: '/admin/push'
      path: '/push'
      fullPath: '/admin/push'
      preLoaderRoute: typeof AdminPushRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/sentence-puzzles': {
      id: '/admin/sentence-puzzles'
      path: '/sentence-puzzles'
      fullPath: '/admin/sentence-puzzles'
      preLoaderRoute: typeof AdminSentencePuzzlesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/sticker-packs': {
      id: '/admin/sticker-packs'
      path: '/sticker-packs'
      fullPath: '/admin/sticker-packs'
      preLoaderRoute: typeof AdminStickerPacksRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/storybooks': {
      id: '/admin/storybooks'
      path: '/storybooks'
      fullPath: '/admin/storybooks'
      preLoaderRoute: typeof AdminStorybooksRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/streaks': {
      id: '/admin/streaks'
      path: '/streaks'
      fullPath: '/admin/streaks'
      preLoaderRoute: typeof AdminStreaksRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/support': {
      id: '/admin/support'
      path: '/support'
      fullPath: '/admin/support'
      preLoaderRoute: typeof AdminSupportRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/term-sheets': {
      id: '/admin/term-sheets'
      path: '/term-sheets'
      fullPath: '/admin/term-sheets'
      preLoaderRoute: typeof AdminTermSheetsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/village': {
      id: '/admin/village'
      path: '/village'
      fullPath: '/admin/village'
      preLoaderRoute: typeof AdminVillageRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/village-maps': {
      id: '/admin/village-maps'
      path: '/village-maps'
      fullPath: '/admin/village-maps'
      preLoaderRoute: typeof AdminVillageMapsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/web': {
      id: '/admin/web'
      path: '/web'
      fullPath: '/admin/web'
      preLoaderRoute: typeof AdminWebRouteImport
      parentRoute: typeof AdminRoute
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/alphabet': {
      id: '/app/alphabet'
      path: '/alphabet'
      fullPath: '/app/alphabet'
      preLoaderRoute: typeof AppAlphabetRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/resources': {
      id: '/app/resources'
      path: '/resources'
      fullPath: '/app/resources'
      preLoaderRoute: typeof AppResourcesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/search': {
      id: '/app/search'
      path: '/search'
      fullPath: '/app/search'
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/subscribe': {
      id: '/app/subscribe'
      path: '/subscribe'
      fullPath: '/app/subscribe'
      preLoaderRoute: typeof AppSubscribeRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/support': {
      id: '/app/support'
      path: '/support'
      fullPath: '/app/support'
      preLoaderRoute: typeof AppSupportRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-up': {
      id: '/auth/sign-up'
      path: '/auth/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/analytics/pulse': {
      id: '/admin/analytics/pulse'
      path: '/pulse'
      fullPath: '/admin/analytics/pulse'
      preLoaderRoute: typeof AdminAnalyticsPulseRouteImport
      parentRoute: typeof AdminAnalyticsRoute
    }
    '/admin/analytics/sessions': {
      id: '/admin/analytics/sessions'
      path: '/sessions'
      fullPath: '/admin/analytics/sessions'
      preLoaderRoute: typeof AdminAnalyticsSessionsRouteImport
      parentRoute: typeof AdminAnalyticsRoute
    }
    '/admin/analytics/timeline': {
      id: '/admin/analytics/timeline'
      path: '/timeline'
      fullPath: '/admin/analytics/timeline'
      preLoaderRoute: typeof AdminAnalyticsTimelineRouteImport
      parentRoute: typeof AdminAnalyticsRoute
    }
    '/admin/crosswords/$id': {
      id: '/admin/crosswords/$id'
      path: '/$id'
      fullPath: '/admin/crosswords/$id'
      preLoaderRoute: typeof AdminCrosswordsIdRouteImport
      parentRoute: typeof AdminCrosswordsRoute
    }
    '/admin/devices/$installationId': {
      id: '/admin/devices/$installationId'
      path: '/$installationId'
      fullPath: '/admin/devices/$installationId'
      preLoaderRoute: typeof AdminDevicesInstallationIdRouteImport
      parentRoute: typeof AdminDevicesRoute
    }
    '/admin/dictionary/': {
      id: '/admin/dictionary/'
      path: '/'
      fullPath: '/admin/dictionary/'
      preLoaderRoute: typeof AdminDictionaryIndexRouteImport
      parentRoute: typeof AdminDictionaryRoute
    }
    '/admin/dictionary/list': {
      id: '/admin/dictionary/list'
      path: '/list'
      fullPath: '/admin/dictionary/list'
      preLoaderRoute: typeof AdminDictionaryListRouteImport
      parentRoute: typeof AdminDictionaryRoute
    }
    '/admin/feedback/$id': {
      id: '/admin/feedback/$id'
      path: '/$id'
      fullPath: '/admin/feedback/$id'
      preLoaderRoute: typeof AdminFeedbackIdRouteImport
      parentRoute: typeof AdminFeedbackRoute
    }
    '/admin/flashcard-sets/$id': {
      id: '/admin/flashcard-sets/$id'
      path: '/$id'
      fullPath: '/admin/flashcard-sets/$id'
      preLoaderRoute: typeof AdminFlashcardSetsIdRouteImport
      parentRoute: typeof AdminFlashcardSetsRoute
    }
    '/admin/games/$slug': {
      id: '/admin/games/$slug'
      path: '/$slug'
      fullPath: '/admin/games/$slug'
      preLoaderRoute: typeof AdminGamesSlugRouteImport
      parentRoute: typeof AdminGamesRoute
    }
    '/admin/sentence-puzzles/$id': {
      id: '/admin/sentence-puzzles/$id'
      path: '/$id'
      fullPath: '/admin/sentence-puzzles/$id'
      preLoaderRoute: typeof AdminSentencePuzzlesIdRouteImport
      parentRoute: typeof AdminSentencePuzzlesRoute
    }
    '/admin/sticker-packs/$id': {
      id: '/admin/sticker-packs/$id'
      path: '/$id'
      fullPath: '/admin/sticker-packs/$id'
      preLoaderRoute: typeof AdminStickerPacksIdRouteImport
      parentRoute: typeof AdminStickerPacksRoute
    }
    '/admin/storybooks/$id': {
      id: '/admin/storybooks/$id'
      path: '/$id'
      fullPath: '/admin/storybooks/$id'
      preLoaderRoute: typeof AdminStorybooksIdRouteImport
      parentRoute: typeof AdminStorybooksRoute
    }
    '/admin/support/$id': {
      id: '/admin/support/$id'
      path: '/$id'
      fullPath: '/admin/support/$id'
      preLoaderRoute: typeof AdminSupportIdRouteImport
      parentRoute: typeof AdminSupportRoute
    }
    '/admin/term-sheets/$id': {
      id: '/admin/term-sheets/$id'
      path: '/$id'
      fullPath: '/admin/term-sheets/$id'
      preLoaderRoute: typeof AdminTermSheetsIdRouteImport
      parentRoute: typeof AdminTermSheetsRoute
    }
    '/admin/term-sheets/practice': {
      id: '/admin/term-sheets/practice'
      path: '/practice'
      fullPath: '/admin/term-sheets/practice'
      preLoaderRoute: typeof AdminTermSheetsPracticeRouteImport
      parentRoute: typeof AdminTermSheetsRoute
    }
    '/admin/users/$userId': {
      id: '/admin/users/$userId'
      path: '/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AdminUsersUserIdRouteImport
      parentRoute: typeof AdminUsersRoute
    }
    '/admin/village-maps/$id': {
      id: '/admin/village-maps/$id'
      path: '/$id'
      fullPath: '/admin/village-maps/$id'
      preLoaderRoute: typeof AdminVillageMapsIdRouteImport
      parentRoute: typeof AdminVillageMapsRoute
    }
    '/app/crosswords/': {
      id: '/app/crosswords/'
      path: '/crosswords'
      fullPath: '/app/crosswords/'
      preLoaderRoute: typeof AppCrosswordsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/crosswords/$date': {
      id: '/app/crosswords/$date'
      path: '/crosswords/$date'
      fullPath: '/app/crosswords/$date'
      preLoaderRoute: typeof AppCrosswordsDateRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/crosswords/leaderboard': {
      id: '/app/crosswords/leaderboard'
      path: '/crosswords/leaderboard'
      fullPath: '/app/crosswords/leaderboard'
      preLoaderRoute: typeof AppCrosswordsLeaderboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/diagrams/$slug': {
      id: '/app/diagrams/$slug'
      path: '/diagrams/$slug'
      fullPath: '/app/diagrams/$slug'
      preLoaderRoute: typeof AppDiagramsSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/flashcards/$slug': {
      id: '/app/flashcards/$slug'
      path: '/flashcards/$slug'
      fullPath: '/app/flashcards/$slug'
      preLoaderRoute: typeof AppFlashcardsSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/games/': {
      id: '/app/games/'
      path: '/games'
      fullPath: '/app/games/'
      preLoaderRoute: typeof AppGamesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/games/$slug': {
      id: '/app/games/$slug'
      path: '/games/$slug'
      fullPath: '/app/games/$slug'
      preLoaderRoute: typeof AppGamesSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/sheets/$slug': {
      id: '/app/sheets/$slug'
      path: '/sheets/$slug'
      fullPath: '/app/sheets/$slug'
      preLoaderRoute: typeof AppSheetsSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/songs/$slug': {
      id: '/app/songs/$slug'
      path: '/songs/$slug'
      fullPath: '/app/songs/$slug'
      preLoaderRoute: typeof AppSongsSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/stickers/': {
      id: '/app/stickers/'
      path: '/stickers'
      fullPath: '/app/stickers/'
      preLoaderRoute: typeof AppStickersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/storybooks/$slug': {
      id: '/app/storybooks/$slug'
      path: '/storybooks/$slug'
      fullPath: '/app/storybooks/$slug'
      preLoaderRoute: typeof AppStorybooksSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/sign-in/': {
      id: '/auth/sign-in/'
      path: '/'
      fullPath: '/auth/sign-in/'
      preLoaderRoute: typeof AuthSignInIndexRouteImport
      parentRoute: typeof AuthSignInRoute
    }
    '/auth/sign-in/$': {
      id: '/auth/sign-in/$'
      path: '/$'
      fullPath: '/auth/sign-in/$'
      preLoaderRoute: typeof AuthSignInSplatRouteImport
      parentRoute: typeof AuthSignInRoute
    }
    '/auth/sign-up/': {
      id: '/auth/sign-up/'
      path: '/'
      fullPath: '/auth/sign-up/'
      preLoaderRoute: typeof AuthSignUpIndexRouteImport
      parentRoute: typeof AuthSignUpRoute
    }
    '/auth/sign-up/$': {
      id: '/auth/sign-up/$'
      path: '/$'
      fullPath: '/auth/sign-up/$'
      preLoaderRoute: typeof AuthSignUpSplatRouteImport
      parentRoute: typeof AuthSignUpRoute
    }
    '/admin/dictionary/entry/$id': {
      id: '/admin/dictionary/entry/$id'
      path: '/entry/$id'
      fullPath: '/admin/dictionary/entry/$id'
      preLoaderRoute: typeof AdminDictionaryEntryIdRouteImport
      parentRoute: typeof AdminDictionaryRoute
    }
    '/app/games/$slug/leaderboard': {
      id: '/app/games/$slug/leaderboard'
      path: '/leaderboard'
      fullPath: '/app/games/$slug/leaderboard'
      preLoaderRoute: typeof AppGamesSlugLeaderboardRouteImport
      parentRoute: typeof AppGamesSlugRoute
    }
    '/app/stickers/scenes/$sceneId': {
      id: '/app/stickers/scenes/$sceneId'
      path: '/stickers/scenes/$sceneId'
      fullPath: '/app/stickers/scenes/$sceneId'
      preLoaderRoute: typeof AppStickersScenesSceneIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AdminAnalyticsRouteChildren {
  AdminAnalyticsPulseRoute: typeof AdminAnalyticsPulseRoute
  AdminAnalyticsSessionsRoute: typeof AdminAnalyticsSessionsRoute
  AdminAnalyticsTimelineRoute: typeof AdminAnalyticsTimelineRoute
}

const AdminAnalyticsRouteChildren: AdminAnalyticsRouteChildren = {
  AdminAnalyticsPulseRoute: AdminAnalyticsPulseRoute,
  AdminAnalyticsSessionsRoute: AdminAnalyticsSessionsRoute,
  AdminAnalyticsTimelineRoute: AdminAnalyticsTimelineRoute,
}

const AdminAnalyticsRouteWithChildren = AdminAnalyticsRoute._addFileChildren(
  AdminAnalyticsRouteChildren,
)

interface AdminCrosswordsRouteChildren {
  AdminCrosswordsIdRoute: typeof AdminCrosswordsIdRoute
}

const AdminCrosswordsRouteChildren: AdminCrosswordsRouteChildren = {
  AdminCrosswordsIdRoute: AdminCrosswordsIdRoute,
}

const AdminCrosswordsRouteWithChildren = AdminCrosswordsRoute._addFileChildren(
  AdminCrosswordsRouteChildren,
)

interface AdminDevicesRouteChildren {
  AdminDevicesInstallationIdRoute: typeof AdminDevicesInstallationIdRoute
}

const AdminDevicesRouteChildren: AdminDevicesRouteChildren = {
  AdminDevicesInstallationIdRoute: AdminDevicesInstallationIdRoute,
}

const AdminDevicesRouteWithChildren = AdminDevicesRoute._addFileChildren(
  AdminDevicesRouteChildren,
)

interface AdminDictionaryRouteChildren {
  AdminDictionaryListRoute: typeof AdminDictionaryListRoute
  AdminDictionaryIndexRoute: typeof AdminDictionaryIndexRoute
  AdminDictionaryEntryIdRoute: typeof AdminDictionaryEntryIdRoute
}

const AdminDictionaryRouteChildren: AdminDictionaryRouteChildren = {
  AdminDictionaryListRoute: AdminDictionaryListRoute,
  AdminDictionaryIndexRoute: AdminDictionaryIndexRoute,
  AdminDictionaryEntryIdRoute: AdminDictionaryEntryIdRoute,
}

const AdminDictionaryRouteWithChildren = AdminDictionaryRoute._addFileChildren(
  AdminDictionaryRouteChildren,
)

interface AdminFeedbackRouteChildren {
  AdminFeedbackIdRoute: typeof AdminFeedbackIdRoute
}

const AdminFeedbackRouteChildren: AdminFeedbackRouteChildren = {
  AdminFeedbackIdRoute: AdminFeedbackIdRoute,
}

const AdminFeedbackRouteWithChildren = AdminFeedbackRoute._addFileChildren(
  AdminFeedbackRouteChildren,
)

interface AdminFlashcardSetsRouteChildren {
  AdminFlashcardSetsIdRoute: typeof AdminFlashcardSetsIdRoute
}

const AdminFlashcardSetsRouteChildren: AdminFlashcardSetsRouteChildren = {
  AdminFlashcardSetsIdRoute: AdminFlashcardSetsIdRoute,
}

const AdminFlashcardSetsRouteWithChildren =
  AdminFlashcardSetsRoute._addFileChildren(AdminFlashcardSetsRouteChildren)

interface AdminGamesRouteChildren {
  AdminGamesSlugRoute: typeof AdminGamesSlugRoute
}

const AdminGamesRouteChildren: AdminGamesRouteChildren = {
  AdminGamesSlugRoute: AdminGamesSlugRoute,
}

const AdminGamesRouteWithChildren = AdminGamesRoute._addFileChildren(
  AdminGamesRouteChildren,
)

interface AdminSentencePuzzlesRouteChildren {
  AdminSentencePuzzlesIdRoute: typeof AdminSentencePuzzlesIdRoute
}

const AdminSentencePuzzlesRouteChildren: AdminSentencePuzzlesRouteChildren = {
  AdminSentencePuzzlesIdRoute: AdminSentencePuzzlesIdRoute,
}

const AdminSentencePuzzlesRouteWithChildren =
  AdminSentencePuzzlesRoute._addFileChildren(AdminSentencePuzzlesRouteChildren)

interface AdminStickerPacksRouteChildren {
  AdminStickerPacksIdRoute: typeof AdminStickerPacksIdRoute
}

const AdminStickerPacksRouteChildren: AdminStickerPacksRouteChildren = {
  AdminStickerPacksIdRoute: AdminStickerPacksIdRoute,
}

const AdminStickerPacksRouteWithChildren =
  AdminStickerPacksRoute._addFileChildren(AdminStickerPacksRouteChildren)

interface AdminStorybooksRouteChildren {
  AdminStorybooksIdRoute: typeof AdminStorybooksIdRoute
}

const AdminStorybooksRouteChildren: AdminStorybooksRouteChildren = {
  AdminStorybooksIdRoute: AdminStorybooksIdRoute,
}

const AdminStorybooksRouteWithChildren = AdminStorybooksRoute._addFileChildren(
  AdminStorybooksRouteChildren,
)

interface AdminSupportRouteChildren {
  AdminSupportIdRoute: typeof AdminSupportIdRoute
}

const AdminSupportRouteChildren: AdminSupportRouteChildren = {
  AdminSupportIdRoute: AdminSupportIdRoute,
}

const AdminSupportRouteWithChildren = AdminSupportRoute._addFileChildren(
  AdminSupportRouteChildren,
)

interface AdminTermSheetsRouteChildren {
  AdminTermSheetsIdRoute: typeof AdminTermSheetsIdRoute
  AdminTermSheetsPracticeRoute: typeof AdminTermSheetsPracticeRoute
}

const AdminTermSheetsRouteChildren: AdminTermSheetsRouteChildren = {
  AdminTermSheetsIdRoute: AdminTermSheetsIdRoute,
  AdminTermSheetsPracticeRoute: AdminTermSheetsPracticeRoute,
}

const AdminTermSheetsRouteWithChildren = AdminTermSheetsRoute._addFileChildren(
  AdminTermSheetsRouteChildren,
)

interface AdminUsersRouteChildren {
  AdminUsersUserIdRoute: typeof AdminUsersUserIdRoute
}

const AdminUsersRouteChildren: AdminUsersRouteChildren = {
  AdminUsersUserIdRoute: AdminUsersUserIdRoute,
}

const AdminUsersRouteWithChildren = AdminUsersRoute._addFileChildren(
  AdminUsersRouteChildren,
)

interface AdminVillageMapsRouteChildren {
  AdminVillageMapsIdRoute: typeof AdminVillageMapsIdRoute
}

const AdminVillageMapsRouteChildren: AdminVillageMapsRouteChildren = {
  AdminVillageMapsIdRoute: AdminVillageMapsIdRoute,
}

const AdminVillageMapsRouteWithChildren =
  AdminVillageMapsRoute._addFileChildren(AdminVillageMapsRouteChildren)

interface AdminRouteChildren {
  AdminAcquisitionRoute: typeof AdminAcquisitionRoute
  AdminActivityRoute: typeof AdminActivityRoute
  AdminAdminUsersRoute: typeof AdminAdminUsersRoute
  AdminAnalyticsRoute: typeof AdminAnalyticsRouteWithChildren
  AdminAppVersionRoute: typeof AdminAppVersionRoute
  AdminAppVersionsRoute: typeof AdminAppVersionsRoute
  AdminCohortsRoute: typeof AdminCohortsRoute
  AdminCrosswordsRoute: typeof AdminCrosswordsRouteWithChildren
  AdminDeviceInfoRoute: typeof AdminDeviceInfoRoute
  AdminDevicesRoute: typeof AdminDevicesRouteWithChildren
  AdminDictionaryRoute: typeof AdminDictionaryRouteWithChildren
  AdminDonationsRoute: typeof AdminDonationsRoute
  AdminEngagementRoute: typeof AdminEngagementRoute
  AdminFeatureFlagsRoute: typeof AdminFeatureFlagsRoute
  AdminFeaturedResourcesRoute: typeof AdminFeaturedResourcesRoute
  AdminFeedbackRoute: typeof AdminFeedbackRouteWithChildren
  AdminFlashcardSetsRoute: typeof AdminFlashcardSetsRouteWithChildren
  AdminGamesRoute: typeof AdminGamesRouteWithChildren
  AdminHeroCardsRoute: typeof AdminHeroCardsRoute
  AdminLearningRoute: typeof AdminLearningRoute
  AdminMetricsRoute: typeof AdminMetricsRoute
  AdminPushRoute: typeof AdminPushRoute
  AdminSentencePuzzlesRoute: typeof AdminSentencePuzzlesRouteWithChildren
  AdminStickerPacksRoute: typeof AdminStickerPacksRouteWithChildren
  AdminStorybooksRoute: typeof AdminStorybooksRouteWithChildren
  AdminStreaksRoute: typeof AdminStreaksRoute
  AdminSupportRoute: typeof AdminSupportRouteWithChildren
  AdminTermSheetsRoute: typeof AdminTermSheetsRouteWithChildren
  AdminUsersRoute: typeof AdminUsersRouteWithChildren
  AdminVillageRoute: typeof AdminVillageRoute
  AdminVillageMapsRoute: typeof AdminVillageMapsRouteWithChildren
  AdminWebRoute: typeof AdminWebRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAcquisitionRoute: AdminAcquisitionRoute,
  AdminActivityRoute: AdminActivityRoute,
  AdminAdminUsersRoute: AdminAdminUsersRoute,
  AdminAnalyticsRoute: AdminAnalyticsRouteWithChildren,
  AdminAppVersionRoute: AdminAppVersionRoute,
  AdminAppVersionsRoute: AdminAppVersionsRoute,
  AdminCohortsRoute: AdminCohortsRoute,
  AdminCrosswordsRoute: AdminCrosswordsRouteWithChildren,
  AdminDeviceInfoRoute: AdminDeviceInfoRoute,
  AdminDevicesRoute: AdminDevicesRouteWithChildren,
  AdminDictionaryRoute: AdminDictionaryRouteWithChildren,
  AdminDonationsRoute: AdminDonationsRoute,
  AdminEngagementRoute: AdminEngagementRoute,
  AdminFeatureFlagsRoute: AdminFeatureFlagsRoute,
  AdminFeaturedResourcesRoute: AdminFeaturedResourcesRoute,
  AdminFeedbackRoute: AdminFeedbackRouteWithChildren,
  AdminFlashcardSetsRoute: AdminFlashcardSetsRouteWithChildren,
  AdminGamesRoute: AdminGamesRouteWithChildren,
  AdminHeroCardsRoute: AdminHeroCardsRoute,
  AdminLearningRoute: AdminLearningRoute,
  AdminMetricsRoute: AdminMetricsRoute,
  AdminPushRoute: AdminPushRoute,
  AdminSentencePuzzlesRoute: AdminSentencePuzzlesRouteWithChildren,
  AdminStickerPacksRoute: AdminStickerPacksRouteWithChildren,
  AdminStorybooksRoute: AdminStorybooksRouteWithChildren,
  AdminStreaksRoute: AdminStreaksRoute,
  AdminSupportRoute: AdminSupportRouteWithChildren,
  AdminTermSheetsRoute: AdminTermSheetsRouteWithChildren,
  AdminUsersRoute: AdminUsersRouteWithChildren,
  AdminVillageRoute: AdminVillageRoute,
  AdminVillageMapsRoute: AdminVillageMapsRouteWithChildren,
  AdminWebRoute: AdminWebRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AppGamesSlugRouteChildren {
  AppGamesSlugLeaderboardRoute: typeof AppGamesSlugLeaderboardRoute
}

const AppGamesSlugRouteChildren: AppGamesSlugRouteChildren = {
  AppGamesSlugLeaderboardRoute: AppGamesSlugLeaderboardRoute,
}

const AppGamesSlugRouteWithChildren = AppGamesSlugRoute._addFileChildren(
  AppGamesSlugRouteChildren,
)

interface AppRouteChildren {
  AppAlphabetRoute: typeof AppAlphabetRoute
  AppResourcesRoute: typeof AppResourcesRoute
  AppSearchRoute: typeof AppSearchRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppSubscribeRoute: typeof AppSubscribeRoute
  AppSupportRoute: typeof AppSupportRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCrosswordsDateRoute: typeof AppCrosswordsDateRoute
  AppCrosswordsLeaderboardRoute: typeof AppCrosswordsLeaderboardRoute
  AppDiagramsSlugRoute: typeof AppDiagramsSlugRoute
  AppFlashcardsSlugRoute: typeof AppFlashcardsSlugRoute
  AppGamesSlugRoute: typeof AppGamesSlugRouteWithChildren
  AppSheetsSlugRoute: typeof AppSheetsSlugRoute
  AppSongsSlugRoute: typeof AppSongsSlugRoute
  AppStorybooksSlugRoute: typeof AppStorybooksSlugRoute
  AppCrosswordsIndexRoute: typeof AppCrosswordsIndexRoute
  AppGamesIndexRoute: typeof AppGamesIndexRoute
  AppStickersIndexRoute: typeof AppStickersIndexRoute
  AppStickersScenesSceneIdRoute: typeof AppStickersScenesSceneIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAlphabetRoute: AppAlphabetRoute,
  AppResourcesRoute: AppResourcesRoute,
  AppSearchRoute: AppSearchRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppSubscribeRoute: AppSubscribeRoute,
  AppSupportRoute: AppSupportRoute,
  AppIndexRoute: AppIndexRoute,
  AppCrosswordsDateRoute: AppCrosswordsDateRoute,
  AppCrosswordsLeaderboardRoute: AppCrosswordsLeaderboardRoute,
  AppDiagramsSlugRoute: AppDiagramsSlugRoute,
  AppFlashcardsSlugRoute: AppFlashcardsSlugRoute,
  AppGamesSlugRoute: AppGamesSlugRouteWithChildren,
  AppSheetsSlugRoute: AppSheetsSlugRoute,
  AppSongsSlugRoute: AppSongsSlugRoute,
  AppStorybooksSlugRoute: AppStorybooksSlugRoute,
  AppCrosswordsIndexRoute: AppCrosswordsIndexRoute,
  AppGamesIndexRoute: AppGamesIndexRoute,
  AppStickersIndexRoute: AppStickersIndexRoute,
  AppStickersScenesSceneIdRoute: AppStickersScenesSceneIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthSignInRouteChildren {
  AuthSignInSplatRoute: typeof AuthSignInSplatRoute
  AuthSignInIndexRoute: typeof AuthSignInIndexRoute
}

const AuthSignInRouteChildren: AuthSignInRouteChildren = {
  AuthSignInSplatRoute: AuthSignInSplatRoute,
  AuthSignInIndexRoute: AuthSignInIndexRoute,
}

const AuthSignInRouteWithChildren = AuthSignInRoute._addFileChildren(
  AuthSignInRouteChildren,
)

interface AuthSignUpRouteChildren {
  AuthSignUpSplatRoute: typeof AuthSignUpSplatRoute
  AuthSignUpIndexRoute: typeof AuthSignUpIndexRoute
}

const AuthSignUpRouteChildren: AuthSignUpRouteChildren = {
  AuthSignUpSplatRoute: AuthSignUpSplatRoute,
  AuthSignUpIndexRoute: AuthSignUpIndexRoute,
}

const AuthSignUpRouteWithChildren = AuthSignUpRoute._addFileChildren(
  AuthSignUpRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  PricingRoute: PricingRoute,
  PrivacyRoute: PrivacyRoute,
  SupportRoute: SupportRoute,
  TermsRoute: TermsRoute,
  AuthSignInRoute: AuthSignInRouteWithChildren,
  AuthSignUpRoute: AuthSignUpRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
